import React, { useCallback, useEffect, useState } from "react";
import { Form } from "formik";

import Textbox from "shared/components/Textbox";
import { useDispatch, useSelector } from "react-redux";
import { setContactDetails } from "redux/actions/checkout";
import { checkEmail } from "redux/actions/auth";
import GenericCheckbox from "app/container/Checkout/Generic/GenericCheckbox";

import api from "api";
import { setAcceptsMarketing } from "redux/actions/checkout";
import { sendEvent } from "shared/DataLayer";

const ContactInformationForm = ({
  isLoggedIn,
  validateForm,
  values,
  handleBlur,
}) => {
  const [validatedEmail, setValidatedEmail] = useState(null);
  const [marketing, setMarketing] = useState(false);

  const dispatch = useDispatch();
  const { acceptsMarketing } = useSelector((s) => s.checkout);

  const onFieldBlur = useCallback(() => {
    validateForm().then((errors) => {
      // Valid email
      setValidatedEmail(errors.email ? null : values.email);

      // Whole form is valid
      if (Object.keys(errors).length === 0) {
        sendEvent("contactComplete", values);
        dispatch(setContactDetails(values));
      }
    });
  }, [dispatch, validateForm, values]);

  // Only set email when it changes
  useEffect(() => {
    if (validatedEmail) {
      sendEvent("emailComplete", validatedEmail);
      dispatch(checkEmail(validatedEmail));
    }
  }, [dispatch, validatedEmail]);

  useEffect(() => {
    if (isLoggedIn) {
      api
        .get("/account/preferences")
        .then((data) => setMarketing(data.data.accepts_marketing));
    }
  }, [isLoggedIn]);

  const onCheckboxChanged = (val) => {
    // Set marketing preferences
    if (isLoggedIn && val) {
      api.put("/account/preferences", {
        accepts_marketing: val,
      });
    }
    sendEvent("marketingChange", val);
    dispatch(setAcceptsMarketing(val));
  };

  return (
    <Form>
      <div className="gkit-form-grid">
        <Textbox
          autoComplete="email"
          containerClass="gkit-col-12"
          disabled={isLoggedIn}
          label="Email"
          required
          name="email"
          onBlur={(e) => {
            handleBlur(e);
            onFieldBlur();
          }}
          placeholder="jane@mail.com"
        />
      </div>
      {!marketing && (
        <div className="gkit-my-3">
          {/* One control, sized down at mobile — this used to be two copies
              behind d-none/d-md-none, which duplicated the input id. */}
          <GenericCheckbox
            label="Send me news of what Grind is up to including new products, exclusive offers and dogs that we like."
            checked={acceptsMarketing}
            id="marketingConsent"
            onChange={onCheckboxChanged}
            labelClassName="gkit-mobile-15"
          />
        </div>
      )}
      <div className="gkit-form-grid gkit-mt-3">
        <Textbox
          autoComplete="given-name"
          containerClass="gkit-col-6"
          disabled={isLoggedIn}
          label="First name"
          required
          name="first_name"
          onBlur={(e) => {
            handleBlur(e);
            onFieldBlur();
          }}
          placeholder="Jane"
        />
        <Textbox
          autoComplete="family-name"
          containerClass="gkit-col-6"
          disabled={isLoggedIn}
          label="Last name"
          required
          name="last_name"
          onBlur={(e) => {
            handleBlur(e);
            onFieldBlur();
          }}
          placeholder="Grind"
        />
      </div>
    </Form>
  );
};

export default ContactInformationForm;
